<template>
  <div>

    <loader v-if="!isLoaded" class="table-loader"></loader>

    <form novalidate v-show="isLoaded">
      <div class="row wizard-tab-container">
        <div class="col-lg-8">

          <h1 class="page-title">{{'protocol.fluency' | trans}}: <span v-if="protocols">{{protocols.title}}</span></h1>
          <h3 class="page-sub-title">
            {{'protocol.condition_tranfer' | trans}}: {{conditionTransfer}}
            <br>
            <span v-if="activeStep.executionSecondsLimit">{{'protocol.executionSeconds', {time: activeStep.executionSecondsLimit } | trans}}</span>
          </h3>

          <div class="row mt-2 mb-3" v-if="isPreviousDateSession && protocolsData && protocolsData.endDate" ref="maxTotalAtemptsCountError" id="maxTotalAtemptsCountError">
            <div class="col-12">
              <div class="alert-danger text-center" v-if="showDatePrevious">
                {{'protocol.enter_another_session_date' | trans}} <strong>{{minDate | toLocaleDateTime}}</strong>
              </div>
              <div class="alert-secondary text-center" v-if="!showDatePrevious">
                {{'protocol.end_session_date' | trans}}: <strong>{{minDate | toLocaleDateTime}}</strong>
              </div>
            </div>
          </div>

          <div class="alert alert-secondary" v-if="!(isClient || isTherapist)">
            <h4 class="row-title">{{'protocol.add_new_stimulus' | trans}}</h4>
            <div class="row">
              <div class="col-10 col-md-11">
                <mdc-textfield type="text"
                               :label="'protocol.buttons.addStimulus' | trans"
                               name="addStimulusItem"
                               :class="{'is-invalid': errors.has('addStimulusItem')}"
                               v-validate="'required|max:1000'"
                               v-model="addStimulusItem"
                               data-vv-validate-on="none"
                               :data-vv-as="'protocol.buttons.addStimulus' | trans"/>
                <span class="invalid-feedback"
                      v-if="errors.has('addStimulusItem')">
                        <strong>{{ errors.first('addStimulusItem') }}</strong>
                    </span>

              </div>
              <div class="col-2 col-md-1">
                <button type="button"
                        class="btn btn-sm btn-rounded btn-add-grey"
                        @click.prevent="addStimulus(addStimulusItem)">
                  <i class="material-icons button-primary btn-fixed">add</i>
                </button>
              </div>
            </div>
          </div>

          <h3 class="row-title mt-5" v-if="activeStep.taskType">
            {{'protocol.checkList' | trans}}:
            {{activeStep.taskType.title}}</h3>

          <div class="alert alert-warning" v-if="stimulusListEmpty">
            {{'protocol.stimulus_list_empty' | trans}}
          </div>

          <div class="alert alert-warning" v-if="maxTotalAtemptsCountError">
            {{'protocol.max_count_for_session' | trans}}
          </div>

          <div v-if="!isMobile && !stimulusListEmpty && phases">
            <div class="mb-2 position-relative wrapper-loader"
                 :class="{'box-shadow': activeStep.withFields}"
                 v-for="(phaseItem, indexPhase) in phases"
                 v-if="visibleList(phaseItem.items)">
              <loader v-if="(!(previousDate && previousTime && previousTime.HH && previousTime.mm) && (isBCBA || isCurator) && isPreviousDateSession) || showDatePrevious" class="table-loader position-absolute without-img"
                      messages=""></loader>
              <h3 class="step-title" v-on:click="phaseItem.visible = !phaseItem.visible" v-if="activeStep.withFields"> {{'protocol.field' | trans}}
                <span>{{indexPhase + +activeStep.minFieldCount}}</span>
                ({{phaseItem.items.length}} {{'protocol.stimulus_count' | trans}})
                <button type="button"
                        class="btn btn-link btn-link__text float-right">
                  <span v-if="phaseItem.countToNextLevel">{{'protocol.assimilate_stimulus', {attribute: phaseItem.countToNextLevel} | trans}}</span>   <span
                    :class="{'arrow-down': phaseItem.visible, 'arrow-up':!phaseItem.visible}"></span>
                </button>
              </h3>

              <table class="table table-sm table-fixed mt-2" v-if="phaseItem.visible">
                <thead class="thead-light">
                <tr>
                  <th class="title-cell">{{'protocol.stimuluses' | trans}}</th>
                  <th>{{'protocol.attempts' | trans}}</th>
                  <th class="table-count" v-if="isBCBA || isCurator">{{'protocol.trial_count' | trans}}</th>
                  <th colspan="2">{{'protocol.result' | trans}}</th>
                </tr>
                </thead>
                <tbody class="gray-700">
                <tr v-for="(stimul,index) in phaseItem.items" :key="stimul.id" v-if="!stimul.moveToNextPhase">
                  <td>{{stimul.description}}</td>
                  <td>{{stimul.attempt}}</td>
                  <td class="table-count" v-if="(isBCBA || isCurator)">
                    <mdc-textfield id="attepmtsCount"
                                   ref="attepmtsCount"
                                   v-on:keydown="changeNumber"
                                   type="number"
                                   min="1"
                                   max="1000"
                                   name="code1"
                                   v-model="stimul.attepmtsCount"
                                   v-validate="'min_value:1|numeric'"/>
                  </td>
                  <td class="results-cell">
                    <div class="mt-2">
                      <span v-for="(answer, index) in stimul.lastAnswers" class="item-box" :class="{'hidden': stimul.lastAnswers.length > 5 && index < (stimul.lastAnswers.length -5)}">
                        {{answer}}
                      </span><span v-for="n in emptyLength(stimul.lastAnswers.length)" class="item-box-light"></span>
                    </div>
                    <div
                        class="mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"
                        v-for="(label, key) in stimul.type.answers">
                      <div
                          class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                        <input :id="'id'+index + stimul.id +key + label.id"
                               type="radio" class="mdc-radio__native-control"
                               v-model="stimul.answer"
                               :name="'radios'+index + stimul.id + key + label.id"
                               :key="label.title+index + stimul.id + key + label.id"
                               :value="label.title+index + stimul.id + key + label.id"
                               :disabled="isDisabled"
                               v-on:change="attemptChange(label.id, stimul,indexPhase, label.title, stimul.attepmtsCount)">
                        <div class="mdc-radio__background" :class="{'disabled' : isDisabled}"
                             :style="{background: label.color}">
                          <div class="mdc-radio__outer-circle"></div>
                          <div class="mdc-radio__inner-circle"></div>
                          <label :for="'id'+index + stimul.id + key + label.id">{{label.title}}</label>
                        </div>
                      </div>
                    </div>
                    <button type="button"
                            class="btn return-btn"
                            :disabled="!(stimul.sessionAnswers[stimul.fieldIndex] ? stimul.sessionAnswers[stimul.fieldIndex].length : false)"
                            @click.prevent="backToPreviousAttempt(stimul.id,indexPhase, stimul, stimul.toNextLevel)">
                      <i class="material-icons mdc-button__icon">undo</i>
                    </button>
                  </td>
                  <td class="text-right action-cell">
                    <button type="button"
                            class="btn btn-link btn-link__table-text"
                            v-if="stimul.toNextLevel && (stimul.fieldIndex != activeStep.maxFieldCount) && activeStep.withFields"
                            @click.prevent="goToNextLevel(stimul.id, stimul, indexPhase)">
                      {{'protocol.to_field' | trans}} {{indexPhase + +activeStep.minFieldCount +1}}
                    </button>
                    <button type="button"
                            class="btn btn-link btn-link__table-text"
                            v-if="(stimul.toNextLevel && (stimul.fieldIndex == (activeStep.maxFieldCount)))  || (stimul.toNextLevel && !activeStep.withFields)"
                            @click.prevent="goToNextLevel(stimul.id, stimul, indexPhase, true)">
                      {{'protocol.to_next_phase' | trans}}
                    </button>

                  </td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>

          <div class="mobile-table" v-if="isMobile && !stimulusListEmpty && phases">


            <div class="mb-2"
                 v-for="(phaseItem, indexPhase) in phases"
                 v-if="visibleList(phaseItem.items)">
              <h3 class="step-title" v-if="activeStep.withFields">{{'protocol.field' | trans}}
                <span>{{indexPhase + +activeStep.minFieldCount}}</span>
                ({{phaseItem.items.length}} {{'protocol.stimulus_count' | trans}})
                <button type="button"
                        class="btn btn-link btn-link__text float-right">
                  <span v-if="phaseItem.countToNextLevel">{{'protocol.assimilate_stimulus', {attribute: phaseItem.countToNextLevel} | trans}}</span>   <span
                    :class="{'arrow-down': phaseItem.visible, 'arrow-up':!phaseItem.visible}"></span>
                </button>
              </h3>

              <div class="mobile-table__head">
                <div class="cell">{{'protocol.stimuluses' | trans}}</div>
                <div class="cell">{{'protocol.attempts' | trans}}</div>
              </div>

              <div class="mobile-table__body">
                <div class="mobile-table__row"
                     v-for="(stimul,index) in phaseItem.items" :key="stimul.id" v-if="!stimul.moveToNextPhase">

                  <div class="container-load" v-if="stimul.answer">
                    <svg viewbox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" :class="{'animate': stimul.answer}">
                      <path d="M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z" stroke="#3da35a" fill="transparent"/>
                    </svg>
                  </div>

                  <div>
                    <div class="cell">{{stimul.description}}</div>
                    <div class="cell">
                      <button type="button"
                              class="btn btn-link btn-link__table-text"
                              v-if="stimul.toNextLevel && (stimul.fieldIndex != activeStep.maxFieldCount) && activeStep.withFields"
                              @click.prevent="goToNextLevel(stimul.id, stimul, indexPhase)">
                        {{'protocol.to_field' | trans}} {{indexPhase + +activeStep.minFieldCount +1}}
                      </button>
                      <button type="button"
                              class="btn btn-link btn-link__table-text"
                              v-if="(stimul.toNextLevel && (stimul.fieldIndex == (activeStep.maxFieldCount)))  || (stimul.toNextLevel && !activeStep.withFields)"
                              @click.prevent="goToNextLevel(stimul.id, stimul, indexPhase, true)">
                        {{'protocol.to_next_phase' | trans}}
                      </button>

                    </div>

                    <div class="cell">{{stimul.attempt}}</div>
                  </div>

                  <div class="mt-2">
                      <span v-for="(answer, index) in stimul.lastAnswers" class="item-box" :class="{'hidden': stimul.lastAnswers.length > 5 && index < (stimul.lastAnswers.length -5)}">
                        {{answer}}
                      </span><span v-for="n in emptyLength(stimul.lastAnswers.length)" class="item-box-light"></span>
                  </div>

                  <div class="mt-2 stimul-row"
                       :class="{'stimul-row-3' : (phaseItem.length/3) == 0}">
                    <div
                        class="mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"
                        v-for="(label, key) in stimul.type.answers">
                      <div
                          class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                        <input :id="'id'+index + stimul.id +key + label.id"
                               type="radio" class="mdc-radio__native-control"
                               v-model="stimul.answer"
                               :name="'radios'+index + stimul.id + key + label.id"
                               :key="label.title+index + stimul.id + key + label.id"
                               :value="label.title+index + stimul.id + key + label.id"
                               v-on:change="attemptChange(label.id, stimul,indexPhase, label.title, stimul.attepmtsCount)">
                        <div class="mdc-radio__background"
                             :style="{background: label.color}">
                          <div class="mdc-radio__outer-circle"></div>
                          <div class="mdc-radio__inner-circle"></div>
                          <label :for="'id'+index + stimul.id + key + label.id">{{label.title}}</label>
                        </div>
                      </div>
                    </div>
                    <button type="button"
                            class="btn return-btn"
                            :disabled="!(stimul.sessionAnswers[stimul.fieldIndex] ? stimul.sessionAnswers[stimul.fieldIndex].length : false)"
                            @click.prevent="backToPreviousAttempt(stimul.id,indexPhase, stimul, stimul.toNextLevel)">
                      <i class="material-icons mdc-button__icon">undo</i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <instruction :text="execution"
                       :header="'protocol.execution' | trans"
                       :short-text-length="180">
          </instruction>
        </div>
      </div>

      <div class="form-group row form-group-button stage-button">
        <div class="col-md-12">

          <button type="submit"
                  v-if="!isClient"
                  class="btn btn-primary btn-sm mr-2"
                  :disabled="disabledSave || (!(previousDate && previousTime && previousTime.HH && previousTime.mm) && (isBCBA || isCurator) && isPreviousDateSession) || showDatePrevious"
                  @click.prevent="saveStage()">
            {{'buttons.save' | trans}}
          </button>

          <router-link class="btn btn-link  btn-sm mr-2 mt-2 mt-md-0"
                       :to="{ name: 'choose-stage'}">
            <span>{{'buttons.back' | trans}}</span>
          </router-link>

        </div>
      </div>
    </form>

    <mdc-dialog v-model="isModalVisible"
                :title="'protocol.confirm_save_conflict_session' | trans"
                :accept="'user.save' | trans"
                :cancel="'user.cancel' | trans"
                @accept="saveSession"
                @cancel="cancelSession">
    </mdc-dialog>

  </div>
</template>

<script>
  import axios from 'axios';
  import trim from 'lodash/trim';
  import findIndex from 'lodash/findIndex';
  import lang from '../../../lang/translator';
  import filter from 'lodash/filter';
  import {loadDTTData} from '../../../mixins/loadDTTData';
  import forIn from 'lodash/forIn';
  import {mapGetters} from 'vuex';
  import forEach from 'lodash/forEach';
  import maxBy from 'lodash/maxBy';
  import {TRANSFER_CONDITION} from '../../protocols/constants.js';
  import orderBy from 'lodash/orderBy';

  export default {
    props: ['protocolId', 'protocolData', 'phaseId', 'stageId'],
    data() {
      return {
        addStimulusItem: null,
        lastPhase: null,
        isModalVisible: false
      };
    },
    mixins: [loadDTTData],

    computed: {
      ...mapGetters('auth', [
        'isClient',
        'isCurator',
        'isBCBA',
        'isTherapist',
      ]),
      isDisabled() {
        let taskLength = 0;
        forEach(this.phases, phase => {
          taskLength += phase.items.length
        })
        return taskLength < 2;
      },
    },

    methods: {

    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/FluencyStage.vue